import {
  ICreatePromotionDTO,
  IGetPromotionsListDTO,
  IUpdatePromotionDTO,
  TCreatePromotionResponse,
  TGetPromotionsListResponse,
  TUpdatePromotionResponse,
  getPromotionEndpoints,
  staticPromotionEndpoints,
} from '@/models/promotion.model';
import { ApiResponse, httpClient } from '@/utils';

class PromotionAPI {
  static createPromotion(data: ICreatePromotionDTO): ApiResponse<TCreatePromotionResponse> {
    const { CREATE_PROMOTION } = staticPromotionEndpoints;
    return httpClient.post<TCreatePromotionResponse>(CREATE_PROMOTION, data);
  }

  static getPromotions({ channelId, ...params }: IGetPromotionsListDTO): ApiResponse<TGetPromotionsListResponse> {
    const { GET_PROMOTIONS_LIST } = getPromotionEndpoints({ channelId });
    return httpClient.get<TGetPromotionsListResponse>(GET_PROMOTIONS_LIST, { params });
  }

  static updatePromotion({ id, ...data }: IUpdatePromotionDTO): ApiResponse<TUpdatePromotionResponse> {
    const { UPDATE_PROMOTION } = getPromotionEndpoints({ id });
    return httpClient.patch<TUpdatePromotionResponse>(UPDATE_PROMOTION, data);
  }
}

export default PromotionAPI;
